
<ion-header>
  <ion-toolbar>
    <!-- <ion-buttons slot="start">
      <ion-button (click)="cancel()">Cancel</ion-button>
    </ion-buttons> -->
    <ion-title class="text-center">{{"Capture" | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()" [strong]="true">X</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <ion-tabs>
    <ion-tab tab="Meta Data Info">
      <div id="info-page">
        <ion-header>
          <ion-toolbar>
            <ion-title>Meta Data Info</ion-title>
          </ion-toolbar>
        </ion-header>
        <ion-content>
          <div class="example-content">Info content</div>
        </ion-content>
      </div>
    </ion-tab>
    <ion-tab tab="custom-metadata">
      <div id="custom-metadata-page">
        @for (mdItem of metaDataItems; track $index) {
          <ion-header>
            <ion-toolbar>
              <ion-title>Meta Data Item</ion-title>
            </ion-toolbar>
          </ion-header>
          <ion-content>
            <ion-item>
                <ion-input labelPlacement="stacked" label="Name" [(ngModel)]="mdItem.name" placeholder="mdItem.defaultValue"></ion-input>
                <ion-input labelPlacement="stacked" label="Label" [(ngModel)]="mdItem.displayName" placeholder="mdItem.displayName"></ion-input>
            </ion-item>
          </ion-content>
        }
      </div>
    </ion-tab>
    <ion-tab-bar slot="bottom">
      <ion-tab-button tab="metadata-info">
        <ion-icon name="info"></ion-icon>
        Meta Data Info
      </ion-tab-button>
      <ion-tab-button tab="custom-metadata">
        <ion-icon name="radio"></ion-icon>
        Cutom Meta Data
      </ion-tab-button>
    </ion-tab-bar>
  </ion-tabs>
</ion-content>
